import { AlignmentType } from "docx";
import type { ResumeTemplateDefinition } from "./types";
import { createDocxResumeDocument } from "./docx-builder";
import { ResumePdfTemplateDocument } from "./pdf-builder";

export const templateOne: ResumeTemplateDefinition<"template-1"> = {
  id: "template-1",
  label: "Aurora Prime",
  description:
    "Single-column aurora-inspired layout with serif headlines tuned for ATS readability.",
  accentColor: "#000000",
  render: (resume) =>
    createDocxResumeDocument(resume, {
      accentColor: "#000000",
      headingFont: "Times New Roman",
      bodyFont: "Calibri",
      headerAlignment: AlignmentType.CENTER,
      headingTransform: "uppercase",
      headingUnderline: true,
      includeOrganizations: true,
      includeHighlights: true,
      contactSeparator: " · ",
      bulletSpacing: 60,
      nameFontSize: 28,
    }),
  renderPdf: (resume) => (
    <ResumePdfTemplateDocument
      resume={resume}
      options={{
        accentColor: "#000000",
        headingFont: "Times New Roman",
        bodyFont: "Calibri",
        headerAlignment: "center",
        headingTransform: "uppercase",
        headingUnderline: true,
        includeOrganizations: true,
        includeHighlights: true,
        contactSeparator: " · ",
        bulletSpacing: 60,
        nameFontSize: 28,
      }}
    />
  ),
};
